export const fa = {
  session: { ending: 'پایان نشست', minutes: 'دقیقه' },
  navigation: { close: 'بستن', open: 'بازکردن', standaloneGroups: ['اصلی', 'سامانه'] as const },
  app: { name: 'اوچال', company: 'فناوران اوچال صنعت تبرستان', slogan: 'اوچال، نمادی از کیفیت', platform: 'PLATFORM / 01' },
  auth: {
    title: 'ورود به فضای کاری',
    subtitle: 'برای دسترسی امن به سامانه، اطلاعات حساب سازمانی خود را وارد کنید.',
    identity: 'نام کاربری یا شماره همراه',
    identityPlaceholder: 'نام کاربری خود را وارد کنید',
    password: 'رمز عبور',
    passwordPlaceholder: 'رمز عبور خود را وارد کنید',
    remember: 'مرا به خاطر بسپار',
    submit: 'ورود به سامانه',
    submitting: 'در حال ورود…',
    hint: 'برای دریافت یا بازیابی اطلاعات ورود با مدیر سامانه تماس بگیرید.',
    invalid: 'اطلاعات ورود صحیح نیست.',
    identityRequired: 'نام کاربری یا شماره همراه را وارد کنید.',
    passwordMin: 'رمز عبور حداقل ۶ نویسه است.',
    showPassword: 'نمایش رمز',
    hidePassword: 'پنهان‌کردن رمز',
    trust: 'زیرساخت امن، ماژولار و آماده رشد',
    brandPanelLabel: 'معرفی پلتفرم اوچال',
    enterpriseEdition: 'نسخه سازمانی',
    brandDescription: 'مرکز یکپارچه مدیریت عملیات، منابع و فرآیندهای سازمانی اوچال',
    capabilitiesLabel: 'ویژگی‌های پلتفرم',
    secureTitle: 'امن و قابل اعتماد',
    secureDescription: 'کنترل دسترسی و حفاظت از نشست‌ها',
    modularTitle: 'یکپارچه و ماژولار',
    modularDescription: 'دسترسی متمرکز به ابزارهای سازمانی',
    fastTitle: 'سریع و در دسترس',
    fastDescription: 'تجربه روان در دسکتاپ و موبایل',
    systemReady: 'سامانه آماده خدمت‌رسانی است',
    secureConnection: 'ارتباط امن',
    copyright: '© ۱۴۰۵ اوچال',
    version: 'پلتفرم سازمانی',
  },
  shell: { search: 'جست‌وجو در سامانه…', notifications: 'اعلان‌ها', theme: 'تغییر پوسته', menu: 'منوی کاربری', logout: 'خروج از حساب', collapse: 'جمع‌کردن منو', expand: 'بازکردن منو', open: 'بازکردن منو', breadcrumbRoot: 'اوچال', panel: 'پنل مدیریت', mobileTitle: 'منوی اصلی', navLabel: 'منوی اصلی', otherGroup: 'سایر', statusTitle: 'سامانه عملیاتی است', statusSubtitle: 'همه سرویس‌ها پایدار', copyright: '© ۱۴۰۵ اوچال', version: 'نسخه ۰.۱.۰' },
  state: { checkingSession: 'در حال بررسی نشست کاربری…', unexpectedTitle: 'خطای پیش‌بینی‌نشده', unexpectedDescription: 'بخشی از سامانه درست بارگذاری نشد.', configurationTitle: 'پیکربندی سامانه معتبر نیست', configurationDescription: 'متغیرهای محیطی را با فایل نمونه تطبیق دهید.', reload: 'بارگذاری دوباره', offline: 'اتصال اینترنت برقرار نیست؛ اطلاعات محلی همچنان در دسترس است.' },
  system: { forbiddenCode: '۴۰۳', forbiddenTitle: 'دسترسی مجاز نیست', forbiddenDescription: 'حساب شما مجوز مشاهده این بخش را ندارد.', notFoundCode: '۴۰۴', notFoundTitle: 'صفحه پیدا نشد', notFoundDescription: 'نشانی واردشده وجود ندارد یا جابه‌جا شده است.', expiredCode: '⏱', expiredTitle: 'نشست شما منقضی شد', expiredDescription: 'برای حفاظت از حساب، لطفاً دوباره وارد سامانه شوید.', maintenanceCode: '⚙', maintenanceTitle: 'سامانه در حال نگهداری است', maintenanceDescription: 'در حال بهبود سرویس هستیم؛ چند دقیقه دیگر دوباره تلاش کنید.', serverCode: '۵۰۰', serverTitle: 'خطا در بارگذاری صفحه', retry: 'تلاش دوباره', back: 'بازگشت به داشبورد', loginAgain: 'ورود دوباره' },
} as const;
